import { selectCategory } from "@/store/slices/category";
import styles from "./banner.module.scss";
import Image from "next/image";
import React from "react";
import { useSelector } from "react-redux";

const BannerDesktop = () => {
  const categoryState = useSelector(selectCategory);

  console.log("categoryState.data", categoryState.data);
  return (
    <>
      {!!categoryState.data?.banner_image && (
        <section className={styles.banner}>
          {categoryState.data.banner_link ? (
            <a
              href={categoryState.data.banner_link}
              target={categoryState.data.banner_link_target || "_self"}
            >
              <Image
                src={categoryState.data.banner_image}
                alt={categoryState.data.title}
                layout="responsive"
                width={1920}
                height={400}
                objectFit="cover"
                unoptimized
                priority
              />
            </a>
          ) : (
            <Image
              src={categoryState.data.banner_image}
              alt={categoryState.data.title}
              layout="responsive"
              width={1920}
              height={400}
              objectFit="cover"
              unoptimized
              priority
            />
          )}
        </section>
      )}
      {!!categoryState.data?.firework_snippet && (
        <div
          className="my-3"
          dangerouslySetInnerHTML={{
            __html: categoryState.data.firework_snippet,
          }}
        ></div>
      )}
    </>
  );
};

export default BannerDesktop;
